import React from 'react';
import { blockStyle, labelStyle, inputStyle } from './trainAgentStyles';

export function TrainAgentRoleBlock({ vm }) {
  const { role, setRole } = vm;
  return (
    <div style={blockStyle}>
      <label style={labelStyle}>1. Função Primordial (role)</label>
      <textarea
        value={role}
        onChange={(e) => setRole(e.target.value)}
        rows={3}
        style={{ ...inputStyle, resize: 'vertical' }}
        placeholder="Objetivo / papel do bot (ex.: atendente comercial, suporte técnico)"
      />
    </div>
  );
}
